import { CoreInitiativesCommentsByIdName } from './name';
import { coreInitiativesCommentsUpdateSyncSlice } from '../update';
import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchInitiativeComment } from '@api';

export const coreInitiativesCommentsByIdPatchAsyncSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [ coreInitiativesCommentsUpdateSyncSlice.syncActionCreator ]
	},
	name: CoreInitiativesCommentsByIdName,
	receive: false,
	request: true,
	requestHandler: patchInitiativeComment
});
